import { useDispatch, useSelector } from "react-redux";
import { loginData, logout } from "../stores/auth";
import { axios, errorResponse } from "../helpers";
import { useEffect, useState } from "react";

const useGetById = (url) => {
  const dispatch = useDispatch();
  const dataLogin = useSelector(loginData);
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState([]);
  const [error, setError] = useState("");
  const [styleData, setStyleData] = useState([]);

  useEffect(() => {}, [data]);

  const handleFetchData = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(`${url}`, {
        headers: {
          Authorization: `Bearer ${dataLogin.data.token}`,
        },
      });
      if (response.data.status) {
        setData(response.data.data);
        setError("");
      } else {
        setError(response.data.message);
      }
    } catch (err) {
      if (errorResponse(err) === "jwt expired") {
        dispatch(logout());
      } else {
        return errorResponse(err);
      }
    } finally {
      setIsLoading(false);
    }
  };

  const handleGetAllStyle = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(`${url}`, {
        headers: {
          Authorization: `Bearer ${dataLogin.data.token}`,
        },
      });
      if (response.data.status) {
        setData(response.data.data);
        setError("");
      } else {
        setError(response.data.message);
      }
    } catch (err) {
      setError(errorResponse(err));
    } finally {
      setIsLoading(false);
    }
  };

  return {
    data,
    error,
    isLoading,
    handleGetAllStyle,
    handleFetchData,
  };
};
export default useGetById;
